import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

export interface IReportsRise {
    uuid?: string;
    id_barragem: string;
    motivo: string;
    empresa_executora: string;
    tipo?: string;
    data_inspecao: string;
    data_dce?: string;
    status_dce?: string;
    responsavel?: string;
    art?: string;
    orgao?: string;
    dpa?: string;
    cri?: string;
    classificacao?: string;
    monitoramentos: Monitoramentos[]; 
    recomendacoes: Recomendacoes[]; 
    verificacaoHidrologica: VerificacaoHidrologica; 
    analiseEstabilidade: AnaliseEstabilidade; 
    anomalias: Anomalias[];
    data_criacao?: string;
}

export interface IMaterials {
    secao?: string,
    condicao?: string,
    fator_seguranca?: string,
    referencia?: string,
}

export interface VerificacaoHidrologica {
    area_drenagem?: number;
    precipitacao_pmp?: number;
    precipitacao_projeto?: number;
    duracao_chuva?: number;
    vazao_maxima?: number;
    na_maximo_operacional?: number;
    na_maximo_maximorum?: number;
    borda_livre?: number;
    bombeamento?: number;
}

export interface AnaliseEstabilidade {
    modos_falha?: string;
    metodo_analise?: string;
    informacoes: InfoAnalises[];
}

export interface InfoAnalises {
    secao?: string;
    condicao?: string;
    fator_seguranca?: string;
    valor_referencia?: string;
}

export interface Monitoramentos {
    tipo?: string;
    destaque?: string;
}

export interface Anomalias {
    anomalia?: string;
    avaliacao?: string;
}

export interface Recomendacoes {
    recomendacao?: string;
    prazo?: string;
}

export interface AvaliacoesAderencia {
    estudo?: string;
    destaques?: string;
}

const getAll = async (rise: string): Promise<IReportsRise[] | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./rises?uuid=${rise}`, {
            headers: {
                Authorization: `${token}`
            }
        });        

        if(response.data){
            return response.data;
        }

        return new Error('Erro ao buscar dados', response.data);
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
        }
    }
};

const get = async (rise: string): Promise<IReportsRise | Error> =>{

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./rise?uuid=${rise}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }

        return new Error('Erro ao buscar dados', response.data);
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
        }
    }
};

const create = async (data: IReportsRise): Promise<string | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.post('./rise', data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }

        return new Error('Erro ao buscar dados', response.data);

    }catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
        }
    }

};

const upgrade = async (data: IReportsRise, rise: string): Promise<string | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.put(`./rise?uuid=${rise}`, data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }

        return new Error('Erro ao buscar dados', response.data);

    }catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
        }
    }

};

export const ReportsServicesRise = {
    getAll,
    get,
    create,
    upgrade
};
